var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66663C9.8995 4.66663 12.25 3.88312 12.25 2.91663C12.25 1.95013 9.8995 1.16663 7 1.16663C4.1005 1.16663 1.75 1.95013 1.75 2.91663C1.75 3.88312 4.1005 4.66663 7 4.66663Z",
    stroke: "#10B981",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.91663V11.0833C1.75 11.5474 2.30312 11.9925 3.28769 12.3207C4.27226 12.6489 5.60761 12.8333 7 12.8333C8.39239 12.8333 9.72774 12.6489 10.7123 12.3207C11.6969 11.9925 12.25 11.5474 12.25 11.0833V2.91663",
    stroke: "#10B981",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 7C1.75 7.46413 2.30312 7.90925 3.28769 8.23744C4.27226 8.56563 5.60761 8.75 7 8.75C8.39239 8.75 9.72774 8.56563 10.7123 8.23744C11.6969 7.90925 12.25 7.46413 12.25 7",
    stroke: "#10B981",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/Revenue.6ab66d4fae2653c91ff45d743063a728.svg";
export { ForwardRef as ReactComponent };